import { KALEP_ACTIONS_COLUMN_KEY } from "../constants";
/**
 * Converting object shaped column definition to array.
 * From consumers we expect an object for historical and type safety reasons.
 * (AFC had object shaped column definition for type safety).
 * react-aria's internals however expect an array. We could change how the collection is
 * built, but so far this hasn't been important enough and we just convert to array here.
 */
export function mapColumnHeaders(columns, inlineActions, sortPinnedToStart) {
    let columnList = Object.entries(columns).map(([columnKey, column]) => {
        return Object.assign(Object.assign({}, column), { kalepColumnKey: columnKey, allowsSorting: Boolean(column.sortable) });
    });
    if (inlineActions && inlineActions.length) {
        columnList.push({
            kalepColumnKey: KALEP_ACTIONS_COLUMN_KEY,
            label: "",
            align: "right",
            allowsSorting: false,
        });
    }
    if (sortPinnedToStart) {
        columnList = columnList.sort(pinnedColumnsSorter);
    }
    return columnList;
}
/**
 * Sorts columns so that pinned columns are first.
 * Pinned columns themselves are sorted as they come in original order.
 */
function pinnedColumnsSorter(a, b) {
    if (a.isPinned && !b.isPinned) {
        return -1;
    }
    if (!a.isPinned && b.isPinned) {
        return 1;
    }
    return 0;
}
